import dayjs from 'dayjs';

export const parseIsoDate = (date?: Date) => (date ? dayjs(date)?.format('YYYY-MM-DDTHH:mm:ss') : undefined);
